/* eslint-disable @ngrx/prefer-effect-callback-in-block-statement */
import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { DateTime } from 'luxon';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { selectVehicleRisks } from '@amfam/policy/data-access/lib/+state/policies/policies.selectors';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';

import { RenewalRateService } from '../services/renewal-rate.service';
import {
  vehicleRenewalRate,
  vehicleRenewalRateError,
  vehicleRenewalRateSuccess
} from './renewal-rate.action';

export const getAddVehicleRenewalRate = createEffect(
  (
    actions$ = inject(Actions),
    store = inject(Store),
    renewalRateService = inject(RenewalRateService),
    featureFlagService = inject(FeatureFlagService)
  ) =>
    actions$.pipe(
      ofType(vehicleRenewalRate),
      concatLatestFrom(() => store.select(selectVehicleRisks)),
      map(([action, risks]) => {
        if (risks && risks.length > 0) {
          for (const risk of risks) {
            if (risk.periodEndDate) {
              const enableRenewalRate = featureFlagService.isEnabled('enablerenewalrate');
              // fromJSDate is safe here - risk.periodEndDate is copied directly from
              // Policy.periodEndDate, which the Policy constructor builds via new Date(...)
              // on an unambiguous 'MM/dd/yyyy h:mm a' string, so it's a real Date already.
              const diffdays = Math.trunc(
                DateTime.fromJSDate(risk.periodEndDate)
                  .startOf('day')
                  .diff(DateTime.now().startOf('day'), 'days').days
              );
              if (diffdays <= 35 && enableRenewalRate) {
                return renewalRateService.renewalRateAddVehicleFeature(action.payload).pipe(
                  map(response =>
                    vehicleRenewalRateSuccess({ payload: { renewalRate: response } })
                  ),
                  catchError(() => of(vehicleRenewalRateError()))
                );
              }
            }
          }
        }
        return of(vehicleRenewalRateError());
      }),
      switchMap(result => result)
    ),
  { functional: true }
);
